import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

const KEY = (pid: string) => ['projects', pid, 'meetings'] as const;

export function useMeetings(projectId: string | undefined) {
  return useQuery({
    queryKey: KEY(projectId ?? ''),
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/meetings`),
    enabled: !!projectId,
  });
}

export function useCreateMeeting(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => apiClient.post(`/api/v1/projects/${pid}/meetings`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useUpdateMeeting(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Record<string, unknown> }) =>
      apiClient.patch(`/api/v1/projects/${pid}/meetings/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useDeleteMeeting(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/api/v1/projects/${pid}/meetings/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}
